import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

// Connects to data-controller="radio"
export default class extends Controller {
  static targets = ["panel", "trigger"];

  connect() {
    this.toggle();
  }

  toggle() {
    this.triggerTargets.forEach((trigger) => {
      const panel = trigger.closest(".js-radio-toggle").nextElementSibling;
      if (trigger.checked) {
        $(panel).stop().slideDown();
      } else {
        $(panel).stop().slideUp();
      }
    });
  }
}
